export default __webpack_public_path__ + "bfc5e2af4289a7f63462ebb263f6bdc2.png";